

import { NgModule, ModuleWithProviders } from '@angular/core';

import { NzMenuModule } from 'ng-zorro-antd/menu'
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { HttpClientModule } from '@angular/common/http';
import { MenuTreeComponent } from './components/menu-tree/menu-tree.component';
import { MmMenuManagementComponent } from './components/menu-management/menu-management.component';
import { NzTreeModule } from 'ng-zorro-antd/tree'
import { NzFormModule } from 'ng-zorro-antd/form'
import { ReactiveFormsModule } from '@angular/forms'
import { NzCardModule } from 'ng-zorro-antd/card'
import { NzButtonModule } from 'ng-zorro-antd/button';
import { MenuFormComponent } from './components/menu-form/menu-form.component'
import { NzTableModule } from 'ng-zorro-antd/table'
import { NzInputModule } from 'ng-zorro-antd/input'
import { MmIconModule } from '../icon';
import { MmI18nModule, TRANSLATION_GROUP_TOKEN } from '../i18n';
import { MmTableModule } from 'mm-web-core/table';
import { NzSelectModule } from 'ng-zorro-antd/select'
import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { mmMenuConstants } from './menu-constants';
import { NzModalModule } from 'ng-zorro-antd/modal'
import { en, zh } from './i18n'
import { NzUploadModule } from 'ng-zorro-antd/upload';
@NgModule({
    imports: [
        NzMenuModule,
        CommonModule,
        NzIconModule,
        HttpClientModule,
        NzTreeModule,
        NzFormModule,
        ReactiveFormsModule,
        NzCardModule,
        NzButtonModule,
        NzTableModule,
        MmIconModule,
        MmI18nModule,
        NzInputModule,
        MmTableModule,
        NzSelectModule,
        NzModalModule,
        NzUploadModule,
    ],
    exports: [MenuTreeComponent, MmMenuManagementComponent],
    declarations: [MenuTreeComponent, MmMenuManagementComponent, MenuFormComponent],
    providers: [],
})
export class MmMenuModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: MmMenuModule,
            providers: [
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: {
                        groupName: mmMenuConstants.translationGroup,
                        translations: {
                            "en": en,
                            "zh": zh
                        }

                    } as TranslationGroup,
                    multi: true
                }
            ]
        }

    }

}
